import { FormSelectListItem } from "src/app/utils/component/form-select-list/model/form-select-list.model";
import { buildSelectListKey2Value } from "src/app/utils/function/form-select-list-helper.util";

export enum FormCategory {
  GENERAL = 'GENERAL',
  CONTRACT_STORAGE = 'CONTRACT_STORAGE',
  OTHER = 'OTHER'
}

export const formCategoryList: FormSelectListItem[] = buildSelectListKey2Value(FormCategory);
